import { ObjectUtil } from 'app/utils/object.util';
import { RatedPower } from '../shared/rated-power';

export class PerformanceMonitoring {

  totalSignalCount: number;
  availableSignalCount: number;
  dataAquisitionTimestamp: number;
  ratedPower: number;
  hours: number;
  history: any;
  alarmsNew: any;
  isLollipop: boolean;
  static mapFromPortfolio(portfolio: any, hours: number) {
    if (portfolio) {
      const ratedPower = portfolio.dataDebbug.WTUR1_MW_rated.sum;
      return new PerformanceMonitoring({
        totalSignalCount: portfolio.totalSignalCount,
        availableSignalCount: portfolio.availableSignalCount,
        dataAquisitionTimestamp: Math.min(new Date().getTime(), portfolio.metaData.dataAquisitionMax.unixTimestamp),
        ratedPower,
        hours,
        history: {
          timestamps: this.generateTimestamps(portfolio),
          actualPower: portfolio.analyze.performanceDataSeriesDifferentSources.WTUR1_W_avg_mag_f.data.map(v => v / 1000000),
          theoreticalPower: portfolio.analyze.performanceDataSeriesDifferentSources.WTUR1_W_avg_theoretical.data.map(v => v / 1000000),
          ratedPower: this.generateRatedPower(portfolio, ratedPower),
          transmittingTurbines: portfolio.dataSeries.turbinesAvailable.data,
          totalTurbines: portfolio.totalSignalCount,
        },
        alarmsNew: portfolio.alarms,
        isLollipop: true
      });
    } else {
      return null;
    }
  }

  static mapFromPark(park: any, hours: number) {
    if (park) {
      const ratedPower = park.dataDebbug.WTUR1_MW_rated.sum;
      return new PerformanceMonitoring({
        totalSignalCount: park.totalSignalCount,
        availableSignalCount: park.availableSignalCount,
        dataAquisitionTimestamp: Math.min(new Date().getTime(), park.metaData.dataAquisitionMax.unixTimestamp),
        ratedPower,
        hours,
        history: {
          timestamps: this.generateTimestamps(park),
          actualPower: park.analyze.performanceDataSeriesDifferentSources.WTUR1_W_avg_mag_f.data.map(v => v / 1000000),
          theoreticalPower: park.analyze.performanceDataSeriesDifferentSources.WTUR1_W_avg_theoretical.data.map(v => v / 1000000),
          ratedPower: this.generateRatedPower(park, ratedPower),
          transmittingTurbines: park.dataSeries.turbinesAvailable.data,
          totalTurbines: park.totalSignalCount,
          weather: this.getHourlyWeather(park.dataSeries, park.analyze.performanceDataSeriesDifferentSources),
          windSpeed: park.dataSeries.WNAC1_WdSpd_avg_mag_f.data
        },
        alarmsNew: park.alarms,
        isLollipop: true

      });
    } else {
      return null;
    }
  }

  static mapFromTurbine(turbine: any, hours: number) {
    if (turbine) {
      const ratedPower = ObjectUtil.getProperty(turbine, 'dataDebbug.WTUR1_kW_rated', null);
      return new PerformanceMonitoring({
        ratedPower,
        hours,
        history: {
          timestamps: this.generateTimestamps(turbine),
          actualPower: turbine.analyze.performanceDataSeriesDifferentSources.WTUR1_W_avg_mag_f.data.map(v => v / 1000),
          theoreticalPower: turbine.analyze.performanceDataSeriesDifferentSources.WTUR1_W_avg_theoretical.data.map(v => v / 1000),
          ratedPower: this.generateRatedPower(turbine, ratedPower),
          windSpeed: turbine.dataSeries.WNAC1_WdSpd_avg_mag_f.data
        },
        alarmsNew: turbine.alarms,
        isLollipop: false
      });
    } else {
      return null;
    }
  }

  static generateRatedPower(data, ratedPower) {
    return RatedPower.generate(ratedPower, data.analyze.performanceDataSeriesDifferentSources.WTUR1_W_avg_theoretical.data.length);
  }

  static generateTimestamps(data): number[] {
    const { startingTS, lastTS, intervalTS } = data.analyze.performanceDataSeriesDifferentSources.WTUR1_W_avg_mag_f;
    const timestamps = [];
    if (startingTS !== lastTS) {
      for (let i = startingTS; i <= lastTS; i += intervalTS) {
        timestamps.push(i);
      }
    }
    return timestamps;
  }


  static getHourlyWeather(dt: any, performanceDataSeriesDifferentSources) {
    const ind = (Math.ceil(new Date(performanceDataSeriesDifferentSources.WTUR1_W_avg_theoretical.startingTS).getTime() / 3600000) * 3600000 - performanceDataSeriesDifferentSources.WTUR1_W_avg_theoretical.startingTS) / performanceDataSeriesDifferentSources.WTUR1_W_avg_theoretical.intervalTS;
    const data = dt.WNAC1_ExTmp_avg_mag_f.data.reduce((filtered, next, i) => {
      const obj: any = {};
      if ((i + ind) % 6 === 0) {
        obj.WNAC1_WdDir_avg_mag_f = dt.WNAC1_WdDir_avg_mag_f.data[i];
        obj.WNAC1_ExTmp_avg_mag_f = next;
        obj.WNAC1_WdSpd_avg_mag_f = dt.WNAC1_WdSpd_avg_mag_f.data[i];
        obj.icon = dt.WEATHER_Park_history_icon.data[i];
        obj.timestamp = performanceDataSeriesDifferentSources.WTUR1_W_avg_mag_f.startingTS + (performanceDataSeriesDifferentSources.WTUR1_W_avg_mag_f.intervalTS * i);
        filtered.push(obj);
      }
      return filtered;
    }, []);
    return data;
  }

  constructor(init: Partial<PerformanceMonitoring>) {
    Object.assign(this, init);
  }

}
